import { css, keyframes } from '@emotion/react';

import { media } from '../shared/styles';

// Fade-in animation for backdrop
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// Mobile: slide up from bottom
const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

// Desktop: scale and fade animation (matching Modal)
const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;

// Backdrop styles - full screen overlay
export const backdropStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(34, 32, 32, 0.7);
  animation: ${fadeIn} 0.15s ease-out forwards;
  z-index: 9998;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// Base container styles (mobile-first: bottom drawer)
export const containerStyles = css`
  position: fixed;
  z-index: 9999;
  background-color: var(--color-base-white);
  box-shadow: var(--shadow-xl, 0 20px 40px 0 rgba(0, 0, 0, 0.3));
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Mobile: full-width bottom drawer */
  bottom: 0;
  left: 0;
  right: 0;
  max-height: 90dvh;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  animation: ${slideUp} 0.3s cubic-bezier(0.32, 0.72, 0, 1) forwards;

  width: 100%;
  padding: var(--spacing-5);

  /* Desktop: centered modal */
  ${media.md} {
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
    max-height: calc(100dvh - var(--spacing-8));
    border-radius: var(--radius-lg);
    animation: ${fadeInScale} 0.2s ease-out forwards;

    width: 32rem; /* 512px */
    max-width: calc(100vw - var(--spacing-8));
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    ${media.md} {
      transform: translate(-50%, -50%);
    }
  }
`;

// Close button styles
export const closeButtonStyles = css`
  position: absolute;
  top: var(--spacing-4);
  right: var(--spacing-4);
  z-index: 1;
`;

// Content area styles
export const contentStyles = css`
  overflow-y: auto;
  flex: 1;
  margin-top: var(--spacing-7);
`;
